export default "__VITE_ASSET__DE_bZbUV__"